import { render, staticRenderFns } from "./SeatingAssignmentMergeTags.vue?vue&type=template&id=7d076bfc"
import script from "./SeatingAssignmentMergeTags.vue?vue&type=script&lang=js"
export * from "./SeatingAssignmentMergeTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports